/**
 * Enable floating-label functionality.
 *
 * @param {object} [options={}] - Optional options.
 * @param {string} [options.containerClass='floating-label'] - The base class name to use.
 */
export async function floatingLabel(options = {}) {
    let labels = document.querySelectorAll(`.${options.containerClass || 'floating-label'}`);

    if (labels.length) {
        let { initFloatingLabel } = await import(/* webpackMode: "lazy" */ './inc/floating-label.async');

        initFloatingLabel(options);
    }
}
